import { BlockOutlined, Cancel, CheckCircle, ChecklistOutlined, Error } from '@/ui/primitives';
import type { SvgIconComponent } from '@mui/icons-material';

export const getStatusIconComponent = (status?: string | null): SvgIconComponent => {
  if (!status) return BlockOutlined;
  if (status === 'passed') return CheckCircle;
  if (status === 'completed') return CheckCircle;
  if (status === 'errored') return Error;
  if (status === 'failed') return Cancel;
  if (status === 'skipped') return BlockOutlined;
  return ChecklistOutlined;
};
